var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {Component, Vue} from "vue-property-decorator";
import UiForm, {
  UiFormController,
  UiFormAnnotations
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import _ from "lodash";
import timeFormatter from "@/utils/time-format";
import API from "@ym-framework/api-utils";
const registerIdCard = require("../../assets/img/example_id.jpg");
export class CompanyVerifyForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.enterprise_name = "";
    this.registration_number = "";
    this.register_photo = "";
    this.person_id_card_front = "";
    this.person_id_card_back = "";
    this.handheld_id_photos = "";
    this.legal_person_name = "";
    this.legal_person_number = "";
    this.legal_person_date = "";
    this.person_access_phone = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u540D\u79F0",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "enterprise_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "registration_number", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u6CD5\u4EBA\u59D3\u540D",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "legal_person_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u8EAB\u4EFD\u8BC1\u53F7\u7801",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "legal_person_number", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u8EAB\u4EFD\u8BC1\u6709\u6548\u671F",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "legal_person_date", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: "\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA\u7535\u8BDD",
      trigger: "blur"
    }
  ])
], CompanyVerifyForm.prototype, "person_access_phone", 2);
let CompanyVerify = class extends Vue {
  constructor() {
    super(...arguments);
    this.formController = new CompanyVerifyForm();
    this.dialogVisible = false;
    this.dialogImageUrl = "";
    this.fileRegisterEXP = "../../assets/img/file.png";
    this.fileRegisterID = registerIdCard;
    this.fileRegisterIDList = [registerIdCard];
    this.submitForm = _.debounce(() => __async(this, null, function* () {
      yield this.submitFormReal();
    }), 400);
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  registPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  registRemove(file, filelist) {
    if (filelist.length === 0) {
      document.querySelector("#registerPhoto").querySelector(".el-upload--picture-card").removeAttribute("style");
    }
  }
  registChange(file, filelist) {
    if (filelist.length > 0) {
      document.querySelector("#registerPhoto").querySelector(".el-upload--picture-card").setAttribute("style", "display:none;");
      this.formController.register_photo = file.raw;
    }
  }
  frontPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  frontRemove(file, filelist) {
    if (filelist.length === 0) {
      document.querySelector("#frontPhoto").querySelector(".el-upload--picture-card").removeAttribute("style");
    }
  }
  frontChange(file, filelist) {
    if (filelist.length > 0) {
      document.querySelector("#frontPhoto").querySelector(".el-upload--picture-card").setAttribute("style", "display:none;");
      this.formController.person_id_card_front = file.raw;
    }
  }
  backPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  backRemove(file, filelist) {
    if (filelist.length === 0) {
      document.querySelector("#backPhoto").querySelector(".el-upload--picture-card").removeAttribute("style");
    }
  }
  backChange(file, filelist) {
    if (filelist.length > 0) {
      document.querySelector("#backPhoto").querySelector(".el-upload--picture-card").setAttribute("style", "display:none;");
      this.formController.person_id_card_back = file.raw;
    }
  }
  handlePreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  handleRemove(file, filelist) {
    if (filelist.length === 0) {
      document.querySelector("#handlePhoto").querySelector(".el-upload--picture-card").removeAttribute("style");
    }
  }
  handleChange(file, filelist) {
    if (filelist.length > 0) {
      document.querySelector("#handlePhoto").querySelector(".el-upload--picture-card").setAttribute("style", "display:none;");
      this.formController.handheld_id_photos = file.raw;
    }
  }
  submitFormReal() {
    return __async(this, null, function* () {
      try {
        this.formController.legal_person_date = timeFormatter.dateformatterDay(this.formController.legal_person_date);
        console.log(this.formController);
        let data = new FormData();
        data.append("enterprise_name", this.formController.enterprise_name);
        data.append("registration_number", this.formController.registration_number);
        data.append("legal_person_name", this.formController.legal_person_name);
        data.append("legal_person_number", this.formController.legal_person_number);
        data.append("legal_person_date", this.formController.legal_person_date);
        data.append("person_access_phone", this.formController.person_access_phone);
        data.append("register_photo", this.formController.register_photo);
        data.append("person_id_card_front", this.formController.person_id_card_front);
        data.append("person_id_card_back", this.formController.person_id_card_back);
        data.append("handheld_id_photos", this.formController.handheld_id_photos);
        yield API.post(`api://base.auth/api/v7/certification`, data);
        this.$emit("toResult");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
CompanyVerify = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit
    }
  })
], CompanyVerify);
export default CompanyVerify;
